import Vue from 'vue';
import { LOGOUT, CHECK_AUTHENTICATION, LOGIN } from './mutation-types';
import {
  applyAuthHeader,
  clearStoredAuthToken,
  getStoredAuthToken,
  setStoredAuthToken,
} from '@/utils/authToken';

export default {
  [CHECK_AUTHENTICATION](state) {
    const token = getStoredAuthToken();

    state.authenticated = !!token;
    state.token = token;
    applyAuthHeader(Vue.$http, token);
  },

  [LOGIN](state, token) {
    const normalizedToken = setStoredAuthToken(token);

    state.authenticated = !!normalizedToken;
    state.token = normalizedToken;
    applyAuthHeader(Vue.$http, normalizedToken);
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.token = '';
    clearStoredAuthToken();
    applyAuthHeader(Vue.$http);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js